import { GeolocationCoords } from '../hooks/useGeolocation';

const SESSION_KEY = 'washpass_user_coords';

export function getCachedCoords(): GeolocationCoords | null {
  try {
    const stored = sessionStorage.getItem(SESSION_KEY);
    return stored ? (JSON.parse(stored) as GeolocationCoords) : null;
  } catch {
    return null;
  }
}

export function saveCoordsToCache(coords: GeolocationCoords): void {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(coords));
  } catch {
    console.error('error on save coords to cache')
  }
}
